import { render, staticRenderFns } from "./ques121.vue?vue&type=template&id=753c4450"
import script from "./ques121.vue?vue&type=script&lang=js"
export * from "./ques121.vue?vue&type=script&lang=js"
import style0 from "./ques121.vue?vue&type=style&index=0&id=753c4450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports